import * as d3 from "d3";
import {extendElementFunctionalities} from "./extendNativeJavascript";
import NullZoomManager from "./Zoom/NullZoomManager";
import ZoomManager from "./Zoom/ZoomManager";

export default class Chart {
    // Public:
    constructor(cParams) {
        this.__saveParams(cParams);
        this.extendElementFunctionalities();
        this._saveChart();
        this._saveChartElement();
        this.selectSvg();
        this.createZoomManager(cParams);
        this.attachManualZoomFunction();
    }

    plot(data) {
        this._inputData = data;
        this.clear();
        this.compute();
        this.draw();
    }

    refresh() {
        this.clear();
        this.draw();
    }

    clear() {
        this._svg.selectAll("*").transition();
        this._svg
            .selectAll("*")
            .selectAll("*")
            .exit()
            .remove();
        this._svg
            .selectAll("*")
            .selectAll("*")
            .remove();
        this._svg
            .selectAll("*")
            .exit()
            .remove();
        this._svg.selectAll("*").remove();
        this.stopSimulation();
        this.deleteTimeouts();
    }

    // Private:
    __saveParams(cParams) {
        this._elementId = cParams.elementId;
        this.__backgroundColor = cParams.backgroundColor;
        this._aspectRatio = cParams.aspectRatio;
    }

    extendElementFunctionalities() {
        const elementId = this._elementId;
        extendElementFunctionalities(elementId);
    }

    _saveChart() {
        const chart = d3.select("#" + this._elementId);
        this._chart = chart;
    }

    _saveChartElement() {
        const id = this._elementId;
        const element = document.getElementById(id);
        this._chartElement = element;
    }

    createZoomManager(cParams) {
        var zoomManager = null;
        const elementId = this._elementId;
        const svg = this._svg;
        try {
            const params = {
                elementId: elementId,
                svg: svg,
                minZoomScale: cParams.minZoomScale,
                autoFitSettings: cParams.autoFitSettings,
            };
            zoomManager = new ZoomManager(params);
            zoomManager.compute();
        } catch (error) {
            zoomManager = new NullZoomManager();
        }
        this._zoomManager = zoomManager;
    }

    selectSvg() {
        const color = this.__backgroundColor;
        const viewBox = this.__computeViewBox();
        this._chart
            .select("svg")
            .style("background-color", color)
            .attr("viewBox", viewBox);
        const svg = this._chart.select("svg");
        this._svg = svg;
    }

    __computeViewBox() {
        const k = this._aspectRatio;
        const width = k;
        const height = 1;
        const offTop = -height / 2;
        const offLeft = -width / 2;
        const viewBox = [offLeft, offTop, width, height];
        return viewBox;
    }

    attachManualZoomFunction() {
        let zoomManager = this._zoomManager;
        if (zoomManager !== undefined) {
            let zoomFunc = zoomManager.getManualZoomFunction();
            if (zoomFunc !== undefined) {
                this._chart.call(zoomFunc).on("dblclick.zoom", null);
            }
        }
    }

    stopSimulation() {
        let simulation = this._simulationFunc;
        const simulationExists = simulation !== undefined;
        if (simulationExists) {
            simulation.nodes([]);
            simulation.stop();
        }
    }

    deleteTimeouts() {
        const elementId = this._elementId;
        const element = document.getElementById(elementId);
        element.deleteAllTimeouts();
    }
}
